export default ({ request }) => ({
  projectMapLoadData(params) {
    return request({
      url: '/digitalCenter/project/info/map',
      method: 'get',
      params,
    })
  },
})
